import styled from 'styled-components';
import AppCSS from '../../../../utils/styled';

export const Components = {
  // Two panes: feeds on the left, the selected feed's ranked list on the right.
  // isSingle: only the ranked list (feed targeting hidden).
  Layout: styled.div<{ isSingle?: boolean }>`
    display: grid;
    grid-template-columns: ${(p) => (p.isSingle ? 'minmax(0, 1fr)' : 'minmax(300px, 380px) minmax(0, 1fr)')};
    gap: 16px;
    align-items: start;
    width: 100%;

    @media (max-width: 1000px) {
      grid-template-columns: minmax(0, 1fr);
    }
  `,
  Pane: styled.section`
    display: flex;
    flex-direction: column;
    min-width: 0;
    background-color: ${AppCSS.colors.white};
    border: 1px solid ${AppCSS.colors.greys.light};
    border-radius: 4px;
  `,
  PaneHeader: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
    padding: 12px 16px;
    border-bottom: 1px solid ${AppCSS.colors.greys.light};
  `,
  List: styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
  `,
  // Used for both feed rows and short rows. `isSelected` also gets a left bar, so it is not colour only.
  Row: styled.li<{ isDragging?: boolean; isDropTarget?: boolean; isSelected?: boolean; isDimmed?: boolean }>`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 16px;
    border-bottom: 1px solid ${AppCSS.colors.greys.light};
    border-top: 2px solid ${(p) => (p.isDropTarget ? AppCSS.colors.blues.darker : 'transparent')};
    border-left: 4px solid ${(p) => (p.isSelected ? AppCSS.colors.blues.darker : 'transparent')};
    opacity: ${(p) => (p.isDragging ? 0.4 : p.isDimmed ? 0.55 : 1)};
    background-color: ${AppCSS.colors.white};
  `,
  Handle: styled.span<{ isDisabled?: boolean }>`
    cursor: ${(p) => (p.isDisabled ? 'not-allowed' : 'grab')};
    user-select: none;
    font-size: 18px;
    line-height: 1;
    color: ${AppCSS.colors.greys.medium};
    opacity: ${(p) => (p.isDisabled ? 0.4 : 1)};
  `,
  Rank: styled.span`
    min-width: 28px;
    text-align: right;
    ${AppCSS.fonts.label12Medium};
    color: ${AppCSS.colors.greys.medium};
  `,
  RowBody: styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  `,
  RowTitle: styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    ${AppCSS.fonts.label14Regular};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  Meta: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.greys.medium};
  `,
  // Editorial "why" line under the meta; one line, ellipsized.
  Why: styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    ${AppCSS.fonts.label12Regular};
    font-style: italic;
    color: ${AppCSS.colors.greys.medium};
  `,
  Actions: styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 6px;
  `,
  ActionButton: styled.button`
    padding: 4px 8px;
    cursor: pointer;
    border: 1px solid ${AppCSS.colors.greys.light};
    border-radius: 4px;
    background-color: ${AppCSS.colors.white};
    ${AppCSS.fonts.label12Medium};
    color: ${AppCSS.colors.blues.veryDark};

    &:disabled {
      cursor: default;
      opacity: 0.4;
    }
  `,
  RankInput: styled.input`
    width: 52px;
    padding: 4px 6px;
    border: 1px solid ${AppCSS.colors.greys.light};
    border-radius: 4px;
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  Empty: styled.div`
    padding: 24px 16px;
    text-align: center;
    ${AppCSS.fonts.label14Regular};
    color: ${AppCSS.colors.greys.medium};
  `,
};
